import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import moment from 'moment';
import AlertManager from 'src/components/alert/AlertManager';

import { TableLibrary } from 'src/components/complex';
import {
  TabMenu,
  ToggleSwitch,
  SelectField,
  SearchTextField,
  TextField,
  MCButton,
  MCText,
  PopoverMenu
} from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import constants from 'src/constants';

import { remCss, getSelectLabel, lang, countFormat, permissions, withRouter } from 'src/helpers';

import Item from './item';
import { activeModel, pendingModel } from './model';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import MCVirtuoso from 'src/components/complex/MCVirtuoso';

class Doctors extends BaseComponent {
  componentDidMount() {
    activeModel.subscribe(this.subscription);
    pendingModel.subscribe(this.subscription);
    if (!activeModel.initFlag) {
      activeModel.refresh();
      pendingModel.refresh();
      activeModel.initFlag = true;
    }
  }

  componentWillUnmount() {
    activeModel.unsubscribe(this.subscription);
    pendingModel.unsubscribe(this.subscription);
    activeModel.initFlag = false;
  }

  switchApproved = (item) => {
    activeModel.updateStatus(
      item,
      item.status === constants.general.userStatus.disabled
        ? constants.general.userStatus.enabled
        : constants.general.userStatus.disabled,
      '',
      () => {}
    );
  };

  renderActive = () => {
    const model = activeModel;

    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();

    const columns = [
      {
        label: LANG_CONST.name,
        sort: { sortKey: 'name' },
        resize: true,
        minWidth: remCss(150),
        renderCell: (item) => {
          return (
            <ShortInfo
              user={item}
              specialist={[]}
              to={permissions.PAGES.ADMIN_DOCTORS_DETAIL_PAGE.match(item.username)}
            />
          );
        }
      },
      {
        label: LANG_CONST.email_phone,
        resize: true,
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <MCText label={item.email} numberOfLines={1} heading size={18} weight={500} />
            <MCText
              label={formatPhoneNumberIntl((item.phoneNumber || '').toString())}
              numberOfLines={1}
              heading
              size={18}
              weight={400}
            />
          </div>
        )
      },
      {
        label: LANG_CONST.specialist,
        resize: true,
        renderCell: (item) => getSelectLabel(constants.general.specialist, item.specialist)
      },
      {
        label: LANG_CONST.degree,
        resize: true,
        width: '5%',
        minWidth: remCss(80),
        renderCell: (item) => item.school
      },
      {
        label: LANG_CONST.commission,
        resize: true,
        sort: { sortKey: 'comission' },
        width: `${remCss(130)}px`,
        renderCell: (item) => (
          <div style={{ display: 'flex', alignItems: 'center', gap: remCss(10) }}>
            <TextField
              style={{ width: remCss(65) }}
              inputProps={{ style: { textAlign: 'center' }, min: 0, max: 100 }}
              type='number'
              name='comission'
              template={5}
              value={item.serviceComission || 0}
              onChange={(n, v) => model.onChangeComission(item, v)}
              onBlur={(n, v) => model.saveComission(item, v)}
            />
            <span>%</span>
          </div>
        )
      },
      {
        label: LANG_CONST.appointments,
        resize: true,
        width: '10%',
        minWidth: remCss(80),
        renderCell: (item) => countFormat(item.appointmentCount)
      },
      {
        label: LANG_CONST.treatments,
        resize: true,
        width: '10%',
        minWidth: remCss(80),
        renderCell: (item) => countFormat(item.treatmentCount)
      },
      {
        label: LANG_CONST.added_date,
        resize: true,
        width: '15%',
        renderCell: (item) => moment(item.created).format('MMMM D, YYYY')
      },
      {
        label: LANG_CONST.active,
        resize: true,
        width: '8%',
        minWidth: remCss(90),
        renderCell: (item) => (
          <ToggleSwitch
            keyId={'toggle-approved-' + item.id}
            checked={item?.status !== constants.general.userStatus.disabled}
            onChange={() => this.switchApproved(item)}
          />
        )
      },
      {
        label: LANG_CONST.actions,
        cellStyles: { textAlign: 'end' },
        width: `${remCss(150)}px`,
        renderCell: (item) => (
          <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
            <MCButton
              label={'Login'}
              small
              radius
              primary
              dark
              onClick={() => {
                permissions.switchToFront();
                model.logAsDoctor(item);
              }}
            />
            <PopoverMenu
              placement={'bottom-end'}
              menu={() => (
                <ul
                  className={'mc-select-field-items'}
                  style={{
                    backgroundColor: 'white',
                    padding: remCss(10)
                  }}
                >
                  <li>
                    <MCButton
                      iconname={BASE_ICONS.CLOSE}
                      width={48}
                      padding={7}
                      light
                      radius
                      secondary
                      onClick={() =>
                        AlertManager.popup(AlertManager.TYPES.WARN, {
                          close: false,
                          title: LANG_CONST.notice.delete,
                          cancelButton: {
                            label: LANG_CONST.buttons.no,
                            action: (actions) => actions.hide()
                          },
                          actionButton: {
                            label: LANG_CONST.buttons.yes,
                            action: (actions) => {
                              actions.setLoading(true);
                              model.remove(item.id, (err, res, success) => {
                                actions.setLoading(false);
                                if (success) {
                                  actions.hide();
                                } else {
                                  alert(`error: ${err}`);
                                }
                              });
                            }
                          }
                        })
                      }
                    />
                  </li>
                </ul>
              )}
              className={'mc-no-style-btn'}
            >
              {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={30} />}
            </PopoverMenu>
          </div>
        )
      }
    ];
    return (
      <TableLibrary
        loading={loading}
        noResults={noResults}
        searchQuery={searchQuery}
        sortBy={model.state.sortBy}
        selectedPage={model.state.pageIndex}
        total={total}
        limit={model.listLimit}
        onSortChange={(sortBy) => {
          model.handleChange('sortBy', sortBy);
          model.setListState({ items: [] }, model.getCurrentId(), null, true);
          model.loadMore();
        }}
        onSetPage={(v) => {
          model.handleChange('pageIndex', v);
          model.setListState({ items: [] }, model.getCurrentId(), null, true);
          model.loadMore();
        }}
        columns={columns}
        data={items}
      />
    );
  };

  renderPending = () => {
    return (
      <MCVirtuoso
        model={pendingModel}
        computeItemKey={(index, item) => item.id + '_' + item.__updated}
        itemContent={(index, item) => <Item item={item} index={index} />}
      />
    );
  };

  onSearchChange = (n, specialist, model) => {
    if (specialist?.toString() === model.input('specialist')?.toString()) return;
    model.setStateSilent({ specialist, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  onSearchTextChange = (text, model) => {
    model.setStateSilent({ search: text, pageIndex: 0 });
    model.handleChangeSearch(text);
    if (!text) {
      model.setListStateSilent({ items: [], total: 0 }, 'search');
      model.refresh();
    }
  };

  render() {
    const model = activeModel;

    return (
      <div className={'mc-container-content mc-all-doctors'}>
        <div className={'mc-container-content__header'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.doctors)}</span>
          <div className={'mc-flex'}>
            <SearchTextField
              template={'2'}
              width={300}
              placeholder={LANG_CONST.search}
              onChange={(text) => {
                this.onSearchTextChange(text, activeModel);
                this.onSearchTextChange(text, pendingModel);
              }}
              value={model.input('search')}
            />
            <SelectField
              template={'6'}
              width={remCss(300)}
              options={constants.general.specialist}
              name={'specialist'}
              placeholder={LANG_CONST.specialist}
              value={model.input('specialist')}
              onChange={(n, specialist) => {
                this.onSearchChange(n, specialist, activeModel);
                this.onSearchChange(n, specialist, pendingModel);
              }}
            />
          </div>
        </div>
        <div className={'mc-container-content__body'} style={{ zIndex: 0 }}>
          <div className={'mc-container-content__body-header'}>
            <div className={'mc-grow'}>
              <TabMenu
                tabs={[
                  { id: 'active', name: LANG_CONST.active_doctor },
                  { id: 'pending', name: LANG_CONST.pending_to_approve }
                ]}
                tab={{ id: model.input('tab') }}
                setTab={(tab) => {
                  if (tab.id === model.input('tab'))
                    if (tab.id === 'pending') pendingModel.refresh();
                    else {
                      model.setListStateSilent({ items: [] });
                      model.loadMore();
                    }
                  model.setState({ tab: tab.id });
                }}
                type={'panner'}
              />
            </div>
          </div>

          <div className={'mc-tab-box-opacity mc-grow'}>
            <div
              className={
                'mc-tab-content mc-flex-col ' +
                (model.input('tab') === 'active' ? '' : 'mc-inactive')
              }
            >
              <div className={'mc-container-content__body-content'}>{this.renderActive()}</div>
            </div>
            <div
              className={
                'mc-tab-content mc-flex-col ' +
                (model.input('tab') !== 'active' ? '' : 'mc-inactive')
              }
            >
              <div className={'mc-flex-col mc-grow'}>{this.renderPending()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Doctors);
